import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { RemoteAppResponse } from './types.tsx';

export const fetchCreateBranchTargets = async (issueId: string): Promise<RemoteAppResponse> => {
	const response = await fetchJson(
		`/rest/dev-status/1.0/issue/create-branch-targets?operation=createBranchTargets&issueId=${issueId}`,
	);

	return response;
};
